import { ChevronRightIcon, PencilIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { HTMLProps, useEffect, useRef } from "react";

import classNames from "../../../utils/classNames";
import openInNewTab from "../../../utils/openInNewTab";
import Tooltip from "../Tooltip";

export function IndeterminateCheckbox({
  indeterminate,
  className = '',
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
  const ref = useRef<HTMLInputElement>(null!)

  const primaryClasses = `checked:bg-primary-600 checked:focus:bg-primary-600 hover:checked:bg-primary-700
    indeterminate:bg-primary-600 hover:indeterminate:bg-primary-700
    focus:ring-primary-600 
  `;

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate
    }
  }, [ref, indeterminate])

  return (
    <input
      type="checkbox"
      ref={ref}
      className={className + " p-3 cursor-pointer " + primaryClasses}
      {...rest}
    />
  );
}

// {
//       id: 'select',
//       header: ({ table }: any) => (
//         <IndeterminateCheckbox
//           {...{
//             checked: table.getIsAllRowsSelected(),
//             indeterminate: table.getIsSomeRowsSelected(),
//             onChange: table.getToggleAllRowsSelectedHandler(),
//           }}
//         />
//       ),
//       cell: ({ row }: any) => (
//         <div className="flex justify-center items-center flex-1 p-1" onClick={(e) => e.stopPropagation()}>
//           <IndeterminateCheckbox
//             {...{
//               id: row.original.id,
//               checked: row.getIsSelected(),
//               disabled: !row.getCanSelect(),
//               indeterminate: row.getIsSomeSelected(),
//               onChange: row.getToggleSelectedHandler(),
//             }}
//           />
//           <button
//             onClick={(e) => { e.stopPropagation(); row.toggleExpanded(); }}
//             style={{ transform: `rotate(${!row.getIsExpanded() ? "0" : "-270"}deg)` }}
//             className="ml-3 p-1 transition duration-500 cursor-pointer border border-gray-400 rounded-full hover:bg-gray-200"
//           >
//             {/* {row.getIsExpanded() ? <ChevronDownIcon className="h-4 w-4" /> : <ChevronRightIcon className="h-4 w-4"/>} */}
//             <ChevronRightIcon className="h-4 w-4" />
//           </button>
//         </div>
//       ),
//     },

// return the above
export default function TableCheckboxCol(
  showDropdown = true,
  showCheckbox = true,
  showEdit = false,
  editUrl = "",
  compact = false
) {
  const padH = compact ? "p-1" : "p-4";
  const padC = compact ? "p-0.5" : "p-1";
  const iconBtn = compact ? "p-0.5" : "p-1";
  const iconSize = compact ? "h-3.5 w-3.5" : "h-4 w-4";
  const cbClass = compact ? "!p-0 h-3.5 w-3.5 min-h-0 min-w-0" : "";
  return {
    id: "select",
    meta: compact
      ? { thClassName: "!w-8 !px-0.5 !py-1", tdClassName: "!w-8 !px-0.5 align-top" }
      : undefined,
    header: ({ table }: any) =>
      showCheckbox ? (
        <div
          className={classNames(
            "flex flex-1 items-center justify-center gap-x-1",
            padH
          )}
        >
          <IndeterminateCheckbox
            className={cbClass}
            checked={table.getIsAllRowsSelected()}
            indeterminate={table.getIsSomeRowsSelected()}
            onChange={table.getToggleAllRowsSelectedHandler()}
          />
          <button
            type="button"
            onClick={() => {
              if (table.getState().rowSelection) table.resetRowSelection();
            }}
            className={classNames(
              `cursor-pointer rounded-full border border-gray-400 transition duration-500 hover:bg-gray-200 ${iconBtn}`,
              table.getSelectedRowModel().rows.length === 0
                ? "pointer-events-none"
                : "border-primary-700 bg-primary-600 text-white hover:bg-primary-700"
            )}
          >
            <XMarkIcon className={iconSize} />
          </button>
        </div>
      ) : null,
    cell: ({ row }: any) => (
      <div
        className={classNames(
          "flex flex-1 items-center justify-center gap-x-1",
          padC
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {showCheckbox && (
          <IndeterminateCheckbox
            className={cbClass}
            id={row.original.id}
            checked={row.getIsSelected()}
            disabled={!row.getCanSelect()}
            indeterminate={row.getIsSomeSelected()}
            onChange={row.getToggleSelectedHandler()}
          />
        )}
        <div className="flex flex-col gap-y-1">
          {showEdit && editUrl !== "" && (
            <Tooltip content="Edit Listing">
              <button
                type="button"
                onClick={(e) => {
                  openInNewTab(`${editUrl}/${row.original.id}`);
                }}
                className={classNames(
                  "cursor-pointer rounded-full border border-gray-400 transition duration-500 hover:bg-gray-200",
                  iconBtn
                )}
              >
                <PencilIcon className={iconSize} />
              </button>
            </Tooltip>
          )}

          {showDropdown && (
            <Tooltip
              content={row.getIsExpanded() ? "Close Details" : "Show Details"}
            >
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  row.toggleExpanded();
                }}
                style={{
                  transform: `rotate(${!row.getIsExpanded() ? "0" : "-270"}deg)`,
                }}
                className={classNames(
                  "cursor-pointer rounded-full border border-gray-400 transition duration-500 hover:bg-gray-200",
                  iconBtn
                )}
              >
                <ChevronRightIcon className={iconSize} />
              </button>
            </Tooltip>
          )}
        </div>
      </div>
    ),
  };
}